// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1MAct","colCheckbox":"styles_colCheckbox__1ax9s"};